import { Component, OnInit } from '@angular/core';
import { SfhSecurityService } from '@sasser/sfh-shared-security'
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private sfhSecurity: SfhSecurityService) {
		sfhSecurity.configure(environment.security, 'Rail360');
  }
}
